import React from "react";
import PropTypes from "prop-types";
import { UTILS } from "utils";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import AppModal from "components/ui/AppModal";
import AppButton from "components/ui/AppButton";
import AppIcon from "components/ui/AppIcon";
import { AreasAction } from "redux/actions";
import {
  useDeleteCitiesMutation,
  useGetAddedCitiesMutation,
} from "redux/shipping-methods/shipping-service";
const DeleteCity = ({ open, selectedRow, onClose, selectedCities }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [deleteCities] = useDeleteCitiesMutation();
  const [getAddedCities] = useGetAddedCitiesMutation();
  const { selectedStore } = useSelector((state) => state.AreasReducer);
  const { isLoading } = useSelector((state) => state.LoaderReducer);

  const delete_Cities = UTILS.withTryCatch(async () => {
    const userDetail = UTILS.getCurrentUser();
    let objectArray = [];
    selectedCities.forEach((city) => {
      objectArray.push(city._id);
    });

    const obj = {
      areas: objectArray,
      brandId: userDetail.brandId,
      storeId: selectedStore.value,
    };

    await deleteCities(obj).unwrap();
    await getAddedCities(obj);
    onClose();
    dispatch(AreasAction.setSync());
  });

  const cityName =
    selectedRow && selectedRow.length === 1
      ? selectedRow[0]?.cityID?.cityNameEN || ""
      : "";

  return (
    <AppModal
      open={open}
      onClose={onClose}
      width={550}
      closable={false}
      loading={isLoading}
      footer={
        <div className="mx-auto flex w-full max-w-[760px] items-center justify-center gap-4">
          <AppButton
            variant="secondary"
            size="lg"
            className=" w-1/2 border border-gray-400 bg-white text-4xl text-gray-500"
            onClick={onClose}
          >
            No, Keep It
          </AppButton>
          <AppButton
            variant="primary"
            size="lg"
            className="w-1/2 text-4xl"
            onClick={delete_Cities}
            loading={isLoading}
          >
            Yes, Delete
          </AppButton>
        </div>
      }
    >
      <div className="flex flex-col items-center px-8 text-center">
        <div className="mb-6 h-44 w-44 mt-6">
          <AppIcon name="trashRed" size={170} className="h-full w-full" />
        </div>
        <h1 className="text-24px font-semibold text-gray-900">Delete City</h1>
        <p className=" text-3xl text-gray-500 mb-0">
          {selectedRow && selectedRow.length === 1
            ? `Are you sure you want to delete ${cityName}`
            : t("Are you sure you want to delete the selected cities")}
        </p>
      </div>
    </AppModal>
  );
};

DeleteCity.propTypes = {
  open: PropTypes.bool,
  handleValues: PropTypes.func,
  onClose: PropTypes.func,
};
export default DeleteCity;
